import EventEmitter from "events";
import TypedEmitter from "typed-emitter";

// Define your emitter's types like that:
// Key: Event name; Value: Listener function signature
declare type MessageEvents = {
  stop: () => void;
}

const messageEmitter = new EventEmitter() as TypedEmitter<MessageEvents>;

export default messageEmitter;
